import React from 'react';

import PropTypes from 'prop-types';

import {
  DEFAULT_HELP_TOOLTIP_MESSAGE,
  DEFAULT_LABEL,
  DEFAULT_NAME,
  DEFAULT_PLACEHOLDER,
  MAX_INPUT_LENGTH_WARNING,
  MIN_INPUT_LENGTH_WARNING,
} from './SeoOgDescription.constants';
import SeoDescription from '../SeoDescription';

import './SeoOgDescription.scss';

const propTypes = {
  description: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
};

const defaultProps = {
  description: undefined,
  placeholder: DEFAULT_PLACEHOLDER,
  required: false,
};

export default function SeoOgDescription({ description: descriptionProp, placeholder, required }) {
  return (
    <SeoDescription
      description={descriptionProp}
      placeholder={placeholder}
      name={DEFAULT_NAME}
      showWarnings
      label={DEFAULT_LABEL}
      helpTooltipMessage={DEFAULT_HELP_TOOLTIP_MESSAGE}
      maxInputLengthWarning={MAX_INPUT_LENGTH_WARNING}
      minInputLengthWarning={MIN_INPUT_LENGTH_WARNING}
      hideAiAssistant
      required={required}
    />
  );
}

SeoOgDescription.propTypes = propTypes;
SeoOgDescription.defaultProps = defaultProps;
